import { createApi } from '@reduxjs/toolkit/query/react';
import { ReauthBaseQuery } from '@skynet/data-auth-api';
import { assistantApiBaseQuery } from '@skynet/data-assistant-api';

// Empty API to use as a base for code generation
// Uses the assistant base query with automatic token refresh
export const baseApi = createApi({
  reducerPath: 'regionsApi',
  baseQuery: ReauthBaseQuery(assistantApiBaseQuery),
  endpoints: () => ({}),
});
